// extracted by mini-css-extract-plugin
export var breadcrumb = "_5-0";
export var breadcrumbArrow = "_5-1";